._assistantTooltip_nlxp5_1 {
  font-size: 14px;
  font-family: "HelveticaNeueW01-55Roma", "HelveticaNeueW02-55Roma", "HelveticaNeueW10-55Roma", "'Helvetica Neue', Helvetica, Arial, Meiryo, 'Hiragino Kaku Gothic Pro W3', 'Hiragino Kaku Gothic Pro', sans-serif";
  color: #20303c;
  padding: 24px 12px 0px 0px;
  box-sizing: border-box;
  min-width: auto;
  padding: 24px 12px 0px 0px;
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  max-width: 100%;
  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0px 6px 26px 0px rgba(19, 55, 82, 0.13);
  padding: 30px;
  display: flex;
  max-width: 408px;
  position: relative; }

._assistantTooltipArrow_nlxp5_30 {
  --margin: 0px;
  --size: 8px;
  height: 0;
  width: 0;
  position: absolute; }

._assistantTooltipArrow_nlxp5_30._arrowTop_nlxp5_37 {
  bottom: calc(100% + var(--margin));
  left: 50%;
  transform: translateX(-50%);
  border-left: var(--size) solid transparent;
  border-right: var(--size) solid transparent;
  border-bottom: var(--size) solid #FFF; }

._assistantTooltipArrow_nlxp5_30._arrowBottom_nlxp5_45 {
  top: calc(100% + var(--margin));
  left: 50%;
  transform: translateX(-50%);
  border-left: var(--size) solid transparent;
  border-right: var(--size) solid transparent;
  border-bottom: var(--size) solid #FFF; }

._assistantTooltipArrow_nlxp5_30._arrowLeft_nlxp5_53 {
  right: calc(100% + var(--margin));
  top: 50%;
  transform: translateY(-50%);
  border-top: var(--size) solid transparent;
  border-right: var(--size) solid #FFF;
  border-bottom: var(--size) solid transparent; }

._assistantTooltipArrow_nlxp5_30._arrowRight_nlxp5_61 {
  left: calc(100% + var(--margin));
  top: 50%;
  transform: translateY(-50%);
  border-top: var(--size) solid transparent;
  border-bottom: var(--size) solid transparent;
  border-left: var(--size) solid #FFF; }
